import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@onwardtravelsolutions/package-react/Components';
import { NoticeType } from '@onwardtravelsolutions/package-react/Enums';
import { Notice } from '@onwardtravelsolutions/package-react/Types';

export default function NoticeBlock({ notice }: { notice: Notice }) {
    let className = 'block p-4 rounded w-full text-center text-white space-y-2';

    switch (notice.type) {
        case NoticeType.Information:
            className += ' bg-success';
            break;
        case NoticeType.Warning:
        case NoticeType.Error:
        default:
            className += ' bg-error';
            break;
    }

    const title = notice.title.length ? (
        <strong className='block mb-1 text-white capitalize'>
            {notice.title}
        </strong>
    ) : null;

    const actions = notice.actions ? (
        <div
            className={
                'flex flex-col pl-3 shrink-0 items-stretch justify-between gap-y-1'
            }
        >
            {notice.actions.map((action) => {
                return (
                    <Button
                        onClick={action.callback}
                        title={action.title}
                        className={
                            'grow align-middle text-center w-full h-full px-6 py-2 text-white transition cursor-pointer rounded-lg bg-stone-950/20 hover:bg-stone-950/25'
                        }
                    >
                        {action.icon && (
                            <FontAwesomeIcon
                                icon={action.icon as IconDefinition}
                                className='mr-1'
                            />
                        )}
                        {action.label ? <span>{action.label}</span> : null}
                    </Button>
                );
            })}
        </div>
    ) : null;

    return (
        <div className={`flex flex-row ${className}`} role='note'>
            <div className='flex flex-col justify-center w-full grow'>
                {title}
                <span className='text-sm'>{notice.body}</span>
            </div>
            {actions}
        </div>
    );
}
